import React from "react";
// import { Link } from 'react-router-dom';
import { FiX , FiMenu } from "react-icons/fi";
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import Scrollspy from 'react-scrollspy';
import { withFirebase } from 'utils/Firebase';
import { AuthUserContext } from '../../utils/Firebase/Session';
import { logoAllDark, logoLight } from 'assets/images';


const Header = (props) => {

    const { firebase } = props

    const history = useHistory()

    const handleLogout = () => {
        firebase.signOut()
          .then(() => history.replace('/'))
          .catch((err) => console.log(err))
    }

    const menuTrigger = () => {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    const CLoseMenuTrigger = () => {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }

    // const stickyHeader = () => {}

    window.addEventListener('scroll', function() {
        var value = window.scrollY;
        if (value > 50) {
            const doc = document.querySelector('.header--fixed')
            if (doc) {
                doc.classList.add('sticky')
            }
        }else{
            const doc = document.querySelector('.header--fixed')
            if (doc) {
                doc.classList.remove('sticky')
            }
        }
    });

    const elements = document.querySelectorAll('.has-droupdown > a');
    for(let i in elements) {
        if(elements.hasOwnProperty(i)) {
            elements[i].onclick = function() {
                this.parentElement.querySelector('.submenu').classList.toggle("active");
                this.classList.toggle("open");
            }
        }
    }
    const { color='default-color' } = props;

    return(
      <AuthUserContext.Consumer>
          {(authUser) => (
            <header className={`header-area formobile-menu header--fixed ${color}`}>
              <div className="header-wrapper" id="header-wrapper">
                  <div className="header-left">
                      <div className="logo header-logo">
                          <a href="/">
                              <img className="logo-1" src={logoLight} alt="Logo Images"/>
                              <img className="logo-2" src={logoAllDark} alt="Logo Images"/>
                          </a>
                      </div>
                  </div>
                  <div className="header-right">
                      <nav className="mainmenunav d-lg-block">
                          <Scrollspy className="mainmenu" currentClassName='is-current' items={['home','about','contact', 'contact', 'profile']}>
                              <li><a href="/">Home</a></li>

                              <li><a href="/about">About Us</a></li>

                              <li><a href="/contact" >Partner Now</a></li>

                              <li><a href="/contact" >Contact Us</a></li>

                              { authUser
                                ? <li className="has-droupdown"><Link to="#"><span>{ authUser.displayName }</span></Link>
                                    <ul className="submenu">
                                        <li><Link to="/account">My Profile</Link></li>
                                        <li><Link to="#" onClick={handleLogout}>Logout</Link></li>
                                    </ul>
                              </li>
                                : <li className="purchase-btn md--hide alert-link nav-link"><Link to="/login"><span>Sign In</span></Link>
                                </li>
                              }
                          </Scrollspy>
                      </nav>
                      {/* Start Humberger Menu  */}
                      <div className="humberger-menu d-block d-lg-none pl--20">
                          <span onClick={menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                      </div>
                      {/* End Humberger Menu  */}
                      <div className="close-menu d-block d-lg-none">
                          <span onClick={CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                      </div>
                  </div>
              </div>
            </header>
          )}
      </AuthUserContext.Consumer>
    )
}

export default withFirebase(Header);
